import React, { useMemo } from 'react'

import { Col, Row } from 'antd'
import { useFormikContext } from 'formik'

import FormHeader from '../../../../../../components/FormHeader/FormHeader'
import { useGetLocationTypesDropdownQuery } from '../../services/locationType'
import { useGetMemberTypesDropdownQuery } from '../../services/memberType'
import { getMessage } from '../../../../../../util/IntlMessages'
import { ListWithCheckbox } from '../ListWithCheckbox'

// This function removes "TODOS" option from list
function removeAllOptionFromList(list) {
  return list?.filter(({ value }) => ![-1, '-1'].includes(value)) || []
}

export function ActionPermissions() {
  const { values, setFieldValue } = useFormikContext()

  const { data: memberTypes } = useGetMemberTypesDropdownQuery({ active: true })
  const { data: locationTypes } = useGetLocationTypesDropdownQuery({ active: true })

  const filteredMemberTypes = useMemo(() => removeAllOptionFromList(memberTypes), [memberTypes])
  const filteredLocationTypes = useMemo(() => removeAllOptionFromList(locationTypes), [locationTypes])

  return (
    <>
      <FormHeader
        title={getMessage('tab.permissions')}
        orientation="left"
        type="horizontal"
        className="actionInfo__permissionsTitle"
      />
      <Row type="flex" justify="start">
        <Col span={12}>
          <ListWithCheckbox
            field="memberTypesIds"
            label={getMessage('actionTypesProfessionalsTypes')}
            setFieldValue={(...args) => setFieldValue(...args)}
            values={values.memberTypesIds || []}
            optionsList={filteredMemberTypes}
          />
        </Col>
        <Col span={12}>
          <ListWithCheckbox
            field="locationTypesIds"
            label={getMessage('locationTypes')}
            setFieldValue={(...args) => setFieldValue(...args)}
            values={values.locationTypesIds || []}
            optionsList={filteredLocationTypes}
          />
        </Col>
      </Row>
    </>
  )
}
